declare var pdc: any;

export function getCurrentUserId(glob = pdc.platform.glob) {
    return glob.AppStore.getCurrentUserId();
}
